import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { blogPosts } from '@/data/blog'
import { BlogCard } from '@/components/BlogCard'

export function RecentBlog() {
  const recent = [...blogPosts]
    .sort((a, b) => +new Date(b.date) - +new Date(a.date))
    .slice(0, 4)
  if (recent.length === 0) return null

  return (
    <section className="container border-t border-border/60 py-16">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Writing</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Notes on optimization, ML, and building things.
          </p>
        </div>
        <Link
          to="/blog"
          className="inline-flex items-center gap-1 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          All writing
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="flex flex-col">
        {recent.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
    </section>
  )
}
